<script lang="tsx" setup>
import { useSlots } from "vue"

const slots = useSlots()
</script>

<template>
  <div
    class="flex flex-col grid-cols-1 lg:grid lg:grid-cols-12 lg:gap-8 gap-8 text-sm"
  >
    <div v-if="slots.meta" class="col-span-3">
      <slot name="meta" />
    </div>

    <div
      v-if="slots.header"
      class="col-span-3 pr-linebreak order-first lg:order-0"
    >
      <slot name="header" />
    </div>

    <div v-if="slots.body" class="lg:col-span-6 lg:col-start-7 lg:order-last">
      <slot name="body" />
    </div>
  </div>
</template>
